const URL_BASE=process.env.REACT_APP_API;

export const URL_LOGIN=`${URL_BASE}/auth/login`;
export const URL_LOGOUT=`${URL_BASE}/auth/logout`;